interface AuthBypassEnvironment {
  bypassFlag?: string;
  hostname?: string;
  isDev?: boolean;
  isElectron?: boolean;
}

export function shouldAllowAuthBypass({
  bypassFlag,
  hostname,
  isDev,
  isElectron,
}: AuthBypassEnvironment): boolean {
  if (bypassFlag !== "true") return false;
  if (isDev || isElectron) return true;
  return isLocalAuthHost(hostname);
}

export function isAuthBypassAllowed(): boolean {
  return shouldAllowAuthBypass({
    bypassFlag: import.meta.env.VITE_BYPASS_AUTH,
    hostname:
      typeof window === "undefined" ? undefined : window.location.hostname,
    isDev: import.meta.env.DEV,
    isElectron:
      typeof window !== "undefined" &&
      Boolean((window as Window & { electron?: unknown }).electron),
  });
}

function isLocalAuthHost(hostname?: string): boolean {
  if (!hostname) return false;
  const normalized = hostname.replace(/^\[|\]$/g, "");
  return (
    normalized === "localhost" ||
    normalized === "127.0.0.1" ||
    normalized === "::1" ||
    normalized.endsWith(".local")
  );
}
